import StyledContainer from "style/styledContainer";
import styled from "styled-components";
import { ReactComponent as LogoSvg } from 'assets/svgs/logo.svg';
import { ReactComponent as LogoSmalSvg } from 'assets/svgs/logo_smal.svg';
import NavBarCom from "./NavBarCom";
import BottomCom from "./BottomCom";
import WalletConnectCom from "components/WalletConnectCom";

const LeftBarCom = () => {
    return (
        <LeftBarWrap>
            <LogoWrap>
                <LogoSmalSvgWrap></LogoSmalSvgWrap>
                <LogoSvgWrap></LogoSvgWrap>
            </LogoWrap>
            <StyledContainer $flex1="1">
                <StyledContainer $height="60px"></StyledContainer>
                <NavBarCom></NavBarCom>
                <StyledContainer $height="40px"></StyledContainer>
                <WalletConnectCom></WalletConnectCom>
            </StyledContainer>
            <BottomCom></BottomCom>
        </LeftBarWrap>
    );
}

const LeftBarWrap = styled(StyledContainer)`
    background-color: ${({theme}) => theme.basicWhite};
    min-height: 100vh;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 180px;


    @media screen and (min-width: 1920px) {
        width: 300px;
    }
    @media screen and (min-width: 1440px) and (max-width: 1920px) {
        width: 220px;
    }
    @media screen and (min-width: 1024px) and (max-width: 1440px) {
        width: 180px;
    }
    @media screen and (min-width: 768px) and (max-width: 1024px) {
        width: 87px;
    }
    @media screen and (max-width: 768px) {
        display: none;
    }
`

const LogoWrap = styled(StyledContainer)`
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px dashed ${({theme}) => theme.leftBarBorder}; 
`
const LogoSvgWrap = styled(LogoSvg)`
    @media screen and (min-width: 1024px) {
        display: block;
    }
    @media screen and (max-width: 1024px) {
        display: none;
    }
`

const LogoSmalSvgWrap = styled(LogoSmalSvg)`
    @media screen and (min-width: 1024px) {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        display: block;
    }
`

export default LeftBarCom